




import Vue from 'vue';
import { iconService } from '../services/IconService';

export default Vue.extend({
  props: ['icon'],
  data() {
    return {
      icons: {...iconService},
    };
  },
});
